"use strict";
// Copyright (c) 2024 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OP_ROLL = exports.OP_PICK = exports.OP_OVER = exports.OP_NIP = exports.OP_DUP = exports.OP_DROP = exports.OP_DEPTH = exports.OP_IFDUP = exports.OP_2SWAP = exports.OP_2ROT = exports.OP_2OVER = exports.OP_3DUP = exports.OP_2DUP = exports.OP_2DROP = exports.OP_FROMALTSTACK = exports.OP_TOALTSTACK = exports.OP_RETURN = exports.OP_VERIFY = exports.OP_ENDIF = exports.OP_ELSE = exports.OP_VERNOTIF = exports.OP_VERIF = exports.OP_NOTIF = exports.OP_IF = exports.OP_VER = exports.OP_NOP = exports.OP_16 = exports.OP_15 = exports.OP_14 = exports.OP_13 = exports.OP_12 = exports.OP_11 = exports.OP_10 = exports.OP_9 = exports.OP_8 = exports.OP_7 = exports.OP_6 = exports.OP_5 = exports.OP_4 = exports.OP_3 = exports.OP_2 = exports.OP_TRUE = exports.OP_1 = exports.OP_RESERVED = exports.OP_1NEGATE = exports.OP_PUSHDATA4 = exports.OP_PUSHDATA2 = exports.OP_PUSHDATA1 = exports.OP_FALSE = exports.OP_0 = void 0;
exports.OP_CHECKSIG = exports.OP_CODESEPARATOR = exports.OP_HASH256 = exports.OP_HASH160 = exports.OP_SHA256 = exports.OP_SHA1 = exports.OP_RIPEMD160 = exports.OP_WITHIN = exports.OP_MAX = exports.OP_MIN = exports.OP_GREATERTHANOREQUAL = exports.OP_LESSTHANOREQUAL = exports.OP_GREATERTHAN = exports.OP_LESSTHAN = exports.OP_NUMNOTEQUAL = exports.OP_NUMEQUALVERIFY = exports.OP_NUMEQUAL = exports.OP_BOOLOR = exports.OP_BOOLAND = exports.OP_RSHIFT = exports.OP_LSHIFT = exports.OP_MOD = exports.OP_DIV = exports.OP_MUL = exports.OP_SUB = exports.OP_ADD = exports.OP_0NOTEQUAL = exports.OP_NOT = exports.OP_ABS = exports.OP_NEGATE = exports.OP_2DIV = exports.OP_2MUL = exports.OP_1SUB = exports.OP_1ADD = exports.OP_RESERVED2 = exports.OP_RESERVED1 = exports.OP_EQUALVERIFY = exports.OP_EQUAL = exports.OP_XOR = exports.OP_OR = exports.OP_AND = exports.OP_INVERT = exports.OP_SIZE = exports.OP_BIN2NUM = exports.OP_NUM2BIN = exports.OP_SPLIT = exports.OP_CAT = exports.OP_TUCK = exports.OP_SWAP = exports.OP_ROT = void 0;
exports.OP_INVALIDOPCODE = exports.OP_PREFIX_END = exports.OP_PREFIX_BEGIN = exports.OP_REVERSEBYTES = exports.OP_CHECKDATASIGVERIFY = exports.OP_CHECKDATASIG = exports.OP_NOP10 = exports.OP_NOP9 = exports.OP_NOP8 = exports.OP_NOP7 = exports.OP_NOP6 = exports.OP_NOP5 = exports.OP_NOP4 = exports.OP_NOP3 = exports.OP_CHECKSEQUENCEVERIFY = exports.OP_NOP2 = exports.OP_CHECKLOCKTIMEVERIFY = exports.OP_NOP1 = exports.OP_CHECKMULTISIGVERIFY = exports.OP_CHECKMULTISIG = exports.OP_CHECKSIGVERIFY = void 0;
// push value
exports.OP_0 = 0x00;
exports.OP_FALSE = exports.OP_0;
exports.OP_PUSHDATA1 = 0x4c;
exports.OP_PUSHDATA2 = 0x4d;
exports.OP_PUSHDATA4 = 0x4e;
exports.OP_1NEGATE = 0x4f;
exports.OP_RESERVED = 0x50;
exports.OP_1 = 0x51;
exports.OP_TRUE = exports.OP_1;
exports.OP_2 = 0x52;
exports.OP_3 = 0x53;
exports.OP_4 = 0x54;
exports.OP_5 = 0x55;
exports.OP_6 = 0x56;
exports.OP_7 = 0x57;
exports.OP_8 = 0x58;
exports.OP_9 = 0x59;
exports.OP_10 = 0x5a;
exports.OP_11 = 0x5b;
exports.OP_12 = 0x5c;
exports.OP_13 = 0x5d;
exports.OP_14 = 0x5e;
exports.OP_15 = 0x5f;
exports.OP_16 = 0x60;
// control
exports.OP_NOP = 0x61;
exports.OP_VER = 0x62;
exports.OP_IF = 0x63;
exports.OP_NOTIF = 0x64;
exports.OP_VERIF = 0x65;
exports.OP_VERNOTIF = 0x66;
exports.OP_ELSE = 0x67;
exports.OP_ENDIF = 0x68;
exports.OP_VERIFY = 0x69;
exports.OP_RETURN = 0x6a;
// stack ops
exports.OP_TOALTSTACK = 0x6b;
exports.OP_FROMALTSTACK = 0x6c;
exports.OP_2DROP = 0x6d;
exports.OP_2DUP = 0x6e;
exports.OP_3DUP = 0x6f;
exports.OP_2OVER = 0x70;
exports.OP_2ROT = 0x71;
exports.OP_2SWAP = 0x72;
exports.OP_IFDUP = 0x73;
exports.OP_DEPTH = 0x74;
exports.OP_DROP = 0x75;
exports.OP_DUP = 0x76;
exports.OP_NIP = 0x77;
exports.OP_OVER = 0x78;
exports.OP_PICK = 0x79;
exports.OP_ROLL = 0x7a;
exports.OP_ROT = 0x7b;
exports.OP_SWAP = 0x7c;
exports.OP_TUCK = 0x7d;
// splice ops
exports.OP_CAT = 0x7e;
exports.OP_SPLIT = 0x7f; // after monolith upgrade (May 2018)
exports.OP_NUM2BIN = 0x80; // after monolith upgrade (May 2018)
exports.OP_BIN2NUM = 0x81; // after monolith upgrade (May 2018)
exports.OP_SIZE = 0x82;
// bit logic
exports.OP_INVERT = 0x83;
exports.OP_AND = 0x84;
exports.OP_OR = 0x85;
exports.OP_XOR = 0x86;
exports.OP_EQUAL = 0x87;
exports.OP_EQUALVERIFY = 0x88;
exports.OP_RESERVED1 = 0x89;
exports.OP_RESERVED2 = 0x8a;
// numeric
exports.OP_1ADD = 0x8b;
exports.OP_1SUB = 0x8c;
exports.OP_2MUL = 0x8d;
exports.OP_2DIV = 0x8e;
exports.OP_NEGATE = 0x8f;
exports.OP_ABS = 0x90;
exports.OP_NOT = 0x91;
exports.OP_0NOTEQUAL = 0x92;
exports.OP_ADD = 0x93;
exports.OP_SUB = 0x94;
exports.OP_MUL = 0x95;
exports.OP_DIV = 0x96;
exports.OP_MOD = 0x97;
exports.OP_LSHIFT = 0x98;
exports.OP_RSHIFT = 0x99;
exports.OP_BOOLAND = 0x9a;
exports.OP_BOOLOR = 0x9b;
exports.OP_NUMEQUAL = 0x9c;
exports.OP_NUMEQUALVERIFY = 0x9d;
exports.OP_NUMNOTEQUAL = 0x9e;
exports.OP_LESSTHAN = 0x9f;
exports.OP_GREATERTHAN = 0xa0;
exports.OP_LESSTHANOREQUAL = 0xa1;
exports.OP_GREATERTHANOREQUAL = 0xa2;
exports.OP_MIN = 0xa3;
exports.OP_MAX = 0xa4;
exports.OP_WITHIN = 0xa5;
// crypto
exports.OP_RIPEMD160 = 0xa6;
exports.OP_SHA1 = 0xa7;
exports.OP_SHA256 = 0xa8;
exports.OP_HASH160 = 0xa9;
exports.OP_HASH256 = 0xaa;
exports.OP_CODESEPARATOR = 0xab;
exports.OP_CHECKSIG = 0xac;
exports.OP_CHECKSIGVERIFY = 0xad;
exports.OP_CHECKMULTISIG = 0xae;
exports.OP_CHECKMULTISIGVERIFY = 0xaf;
// expansion
exports.OP_NOP1 = 0xb0;
exports.OP_CHECKLOCKTIMEVERIFY = 0xb1;
exports.OP_NOP2 = exports.OP_CHECKLOCKTIMEVERIFY;
exports.OP_CHECKSEQUENCEVERIFY = 0xb2;
exports.OP_NOP3 = exports.OP_CHECKSEQUENCEVERIFY;
exports.OP_NOP4 = 0xb3;
exports.OP_NOP5 = 0xb4;
exports.OP_NOP6 = 0xb5;
exports.OP_NOP7 = 0xb6;
exports.OP_NOP8 = 0xb7;
exports.OP_NOP9 = 0xb8;
exports.OP_NOP10 = 0xb9;
// More crypto
exports.OP_CHECKDATASIG = 0xba;
exports.OP_CHECKDATASIGVERIFY = 0xbb;
// additional byte string operations
exports.OP_REVERSEBYTES = 0xbc;
// multi-byte opcodes
exports.OP_PREFIX_BEGIN = 0xf0;
exports.OP_PREFIX_END = 0xf7;
exports.OP_INVALIDOPCODE = 0xff;
//# sourceMappingURL=opcode.js.map